import React from 'react';
import WimHofImg from '../../imgs/wim_hof_logo.jpg'
import Flyer from '../../imgs/flyer.JPG'

const WimHof: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-4 text-center">
          Wim Hof Fundamentals Workshop
        </h1>
        <h1 className="text-3xl font-bold text-darkgreentext mb-4 text-center">
        Upcoming Event!
      </h1>
      <div className="flex items-center justify-center bg-lighttan mb-12">
            <img
            src={Flyer}
            alt="Flyer"
            className="w-1/3 h-auto rounded-lg shadow-lg object-cover object-center"
            />
        </div>
      <div className="flex justify-center pb-8 mb-12">
        <a
          href="https://calendly.com/seanmotiv8living/wimhofmethodfundamentals?back=1"
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>
        <div className="flex items-center justify-center bg-lighttan">
            <img
            src={WimHofImg}
            alt="Wim Hof Logo"
            className="w-3/4 h-auto rounded-lg shadow-lg object-cover object-center"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
            Begin or strengthen your Wim Hof Method practice by delving into the breath, the cold, and the proper mindset 
            that comprise the Wim Hof Method.  Sean is a certified Wim Hof Method instructor and trained with Wim Hof himself!
        </p>
      </div>
      
    </div>
  );
};

export default WimHof;
